import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

interface NavMenuItem {
  label: string;
  path: string;
}

const BOT_OPTIONS = [
  { label: "Azul - Aeroportos (19 fichas)", value: "1174" },
  { label: "Azul - CargoExpress (2 fichas)", value: "1096" },
  { label: "Azul - Céu (2042 fichas)", value: "996" },
  { label: "Azul - Chat Unique (13 fichas)", value: "1216" },
  { label: "Azul - Concierge (9 fichas)", value: "1185" },
  { label: "Azul - Deixa que eu resolvo (8 fichas)", value: "1229" },
  { label: "Azul - Reacomodação (20 fichas)", value: "1208" },
  { label: "De Olho Na Experiência - Azul (23 fichas)", value: "1217" },
];

const menuItems: NavMenuItem[] = [
  { label: "Template List (Whats)", path: "/template-list" },
  { label: "Template Create (Whats)", path: "/template-create" },
  { label: "Trigger List (Whats)", path: "/trigger-list" },
  { label: "Template Trigger (Whats)", path: "/template-trigger" },
  { label: "Template List (Teams)", path: "/template-list-teams" },
  { label: "Template Create (Teams)", path: "/template-create-teams" },
  { label: "Template Trigger (Teams)", path: "/template-trigger-teams" },
  { label: "User Manager List", path: "/user-manager-list" },
  { label: "Configuration", path: "/user-manager-configuration" },
];

export function FloatingNavMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const isDevMode = process.env.REACT_APP_IS_PROD === "false";

  if (!isDevMode) {
    return null;
  }

  const currentBotId = searchParams.get("bot_id") ?? "";

  const handleNavigate = (path: string) => {
    const paramsString = searchParams.toString();
    const fullPath = paramsString ? `${path}?${paramsString}` : path;
    navigate(fullPath);
    setIsOpen(false);
  };

  const handleBotChange = (newBotId: string) => {
    const params = new URLSearchParams(searchParams.toString());
    params.set("bot_id", newBotId);
    setSearchParams(params);
    setIsOpen(false);
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        zIndex: 9999,
      }}
    >
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          width: "60px",
          height: "60px",
          borderRadius: "50%",
          backgroundColor: "#004488",
          color: "#ffffff",
          border: "none",
          cursor: "pointer",
          fontSize: "24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3)",
          transition: "transform 0.2s",
        }}
      >
        {isOpen ? "✕" : "☰"}
      </button>

      {isOpen && (
        <div
          style={{
            position: "absolute",
            bottom: "70px",
            right: "0",
            backgroundColor: "#ffffff",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
            padding: "10px",
            minWidth: "250px",
            maxHeight: "400px",
            overflowY: "auto",
          }}
        >
          <div
            style={{
              padding: "8px 12px",
              marginBottom: "8px",
              fontWeight: "bold",
              color: "#004488",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            Quick Navigation (DEV)
          </div>

          <div style={{ padding: "4px 12px 8px", borderBottom: "1px solid #e0e0e0", marginBottom: "8px" }}>
            <div style={{ fontSize: "11px", fontWeight: "bold", color: "#666", marginBottom: "6px", textTransform: "uppercase" }}>
              Bot ID
            </div>
            <select
              value={currentBotId}
              onChange={(e) => handleBotChange(e.target.value)}
              style={{
                width: "100%",
                padding: "6px 8px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                fontSize: "13px",
                color: "#333",
                cursor: "pointer",
                backgroundColor: "#fff",
              }}
            >
              <option value="" disabled>Selecione um bot...</option>
              {BOT_OPTIONS.map((bot) => (
                <option key={bot.value} value={bot.value}>
                  {bot.label}
                </option>
              ))}
            </select>
          </div>

          {menuItems.map((item) => (
            <button
              key={item.path}
              onClick={() => handleNavigate(item.path)}
              style={{
                display: "block",
                width: "100%",
                padding: "10px 12px",
                marginBottom: "4px",
                backgroundColor: "transparent",
                border: "none",
                borderRadius: "4px",
                textAlign: "left",
                cursor: "pointer",
                color: "#333",
                fontSize: "14px",
                transition: "background-color 0.2s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#f0f0f0")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "transparent")
              }
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
